import { render } from "./AddTask.vue?vue&type=template&id=058cf3b1&scoped=true"
import script from "./AddTask.vue?vue&type=script&lang=js"
export * from "./AddTask.vue?vue&type=script&lang=js"

import "./AddTask.vue?vue&type=style&index=0&id=058cf3b1&scoped=true&lang=css"

import exportComponent from "C:\\development\\vueproject\\test\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-058cf3b1"]])

export default __exports__